import React, { ReactNode } from 'react';
import BodyBlocker from '../BodyBlocker';
import styled from 'styled-components';

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1035;
`;

const Box = styled.div`
    background: var(--page-bg);
    max-width: 500px;
    padding: var(--pad-x);
    position: relative;
    width: 90%;

    body.theme-platinum & {
        background: var(--text-primary);
        color: #000;
    }

    body.theme-market & {
        background: var(--text-primary);
        color: var(--page-bg);
    }
`;

const Close = styled.i`
    cursor: pointer;
    right: 1rem;
    position: absolute;
    top: 1rem;
`;

interface PopupProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
}

const Popup: React.FC<PopupProps> = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <>
            <BodyBlocker />
            <Container>
                <Box className='dyn-modal-dialog'>
                    {onClose && <Close className="fal fa-times" onClick={onClose}></Close>}
                    <div>
                        {children}
                    </div>
                </Box>
            </Container>
        </>
    );
};

export default Popup;